import React from "react";
import { Booking } from "../../models/booking";
import { AppContext } from "../../services/AppContext"
import { convertUTCToIST, formatDate } from '../components/common/utils'
import "../../../styles/commonStyle.css";

interface BookingDetailsProps {
  booking: Booking | undefined;
}

const BookingDetails: React.FC<BookingDetailsProps> = ({ booking }) => {

  return (
    <div className="card shadow-sm mt-3" style={{  borderRadius: "0.5rem", backgroundColor: "white" }}>
      <div className="card-body">
        <h5 className="card-title fw-bold text-start mb-3">Booking Details</h5>
        <hr className="mb-3" />
        <div className="row mb-2 customTextSm">
          <div className="col-4 fw-bold text-start">Booking #:</div>
          <div className="col-8 text-start">{booking?.bookingId}</div>
        </div>
        <div className="row mb-2 customTextSm">
          <div className="col-4 fw-bold text-start">Name:</div>
          <div className="col-8 text-start">{booking?.name}</div>
        </div>
        <div className="row mb-2 customTextSm">
          <div className="col-4 fw-bold text-start">Phone:</div>
          <div className="col-8 text-start">{booking?.phone}</div>
        </div>
        <div className="row mb-2 customTextSm">
          <div className="col-4 fw-bold text-start">From:</div>
          <div className="col-8 text-start">{booking?.fromAddress}</div>
        </div>
        <div className="row mb-2 customTextSm">
          <div className="col-4 fw-bold text-start">To:</div>
          <div className="col-8 text-start">{booking?.toAddress}</div>
        </div>
        <div className="row mb-2 customTextSm">
          <div className="col-4 fw-bold text-start">Created:</div>
          <div className="col-8 text-start">
            {booking?.createdDate ? formatDate(booking.createdDate).toLocaleString() : "N/A"}
          </div>
        </div>
        <div className="row mb-2 customTextSm">
          <div className="col-4 fw-bold text-start">Trip Date:</div>
          <div className="col-8 text-start">
            {booking?.bookingDate ? convertUTCToIST(booking?.bookingDate) : "N/A"}
          </div>
        </div>
        <div className="row mb-2 customTextSm">
          <div className="col-4 fw-bold text-start">Car Model:</div>
          <div className="col-8 text-start">
            {booking?.selectedCarModel + " " + AppContext?.selectedCar?.carType}
          </div>
        </div>
        <div className="row mb-2 customTextSm">
          <div className="col-4 fw-bold text-start">Return:</div>
          <div className="col-8 text-start">{booking?.returnRide ? "Yes" : "No"}</div>
        </div>
      </div>
    </div>

  );
};

export default BookingDetails;
